import {
  SET_ALL_DATA_OF_ADMIN_APPOINTMENTS,
  SET_APPOINTMENTS_ADMIN_APPOINTMENTS,
  SET_FILTERED_ADMIN_APPOINTMENTS,
  SET_PAGES_DATA_ADMIN_APPOINTMENTS,
  SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS,
  RESET_ALL_ADMIN_APPOINTMENTS_DATA,
  SET_HAS_MORE_PAGE_APPOINTMENTS,
  PREPEND_NEW_APPOINTMENT_ADMIN,
} from "../../../action/admin/appointments/type";

const initialState = {
  page: 0,
  total: 0,
  pages: 0,
  appointments: [],
  filtered: [],
  shouldUpdate: false,
  hasMore: false,
};

const adminAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_DATA_OF_ADMIN_APPOINTMENTS:
      return {
        ...state,
        page: action.payload?.page || 0,
        total: action.payload?.total || 0,
        pages: action.payload?.pages || 0,
        appointments: action.payload?.appointments || [],
        filtered: action.payload?.appointments || [],
      };

    case SET_APPOINTMENTS_ADMIN_APPOINTMENTS:
      return {
        ...state,
        appointments: action?.payload || [],
      };

    case SET_FILTERED_ADMIN_APPOINTMENTS:
      return {
        ...state,
        filtered: action.payload || [],
      };

    case SET_PAGES_DATA_ADMIN_APPOINTMENTS:
      return {
        ...state,
        page: action?.payload?.page || 0,
        pages: action?.payload?.pages || 0,
        total: action?.payload?.total || 0,
      };

    case SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS:
      return {
        ...state,
        shouldUpdate: action?.payload || false,
      };

    case SET_HAS_MORE_PAGE_APPOINTMENTS :
        return {
            ...state,
            hasMore: action.payload
        }

    case PREPEND_NEW_APPOINTMENT_ADMIN:
      return {
        ...state,
        appointments: [action.payload, ...state.appointments],
        filtered: [action.payload, ...state.filtered],
      };

    case RESET_ALL_ADMIN_APPOINTMENTS_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default adminAppointmentsReducer;